// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar, { Props as AvatarProps } from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: AvatarProps) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.photoURL}
      alt={user?.firstname}
      color={user?.photoURL ? 'default' : createAvatar(user?.firstname).color}
      {...other}
    >
      {createAvatar(user?.firstname).name}
    </Avatar>
  );
}
